module.exports = __webpack_public_path__ + "static/media/arrow-circle-empty-right.58598294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-empty-right.svg
// module id = 321
// module chunks = 0